// TODO もう使ってない

import { client as request } from "./request";
import ProjectMember from "@/models/project-member";

/**
 * 現場に所属するユーザーを取得する
 */
export async function getProjectMembers(projectId: any) {
  const members = await request.get("get_project_members.php", {
    projectId
  });
  return members.map((m: any) => new ProjectMember(m));
}

/**
 * 現場のメンバーを追加する
 */
export async function appendProjectMember(projectId: any, staffId: any) {
  const d = new FormData();
  d.append("projectId", String(projectId));
  d.append("staffId", String(staffId));
  await request.post("append_project_member.php", d);
}

/**
 * 現場のメンバーを追放する
 */
export async function removeProjectMember(projectId: any, staffId: any) {
  const d = new FormData();
  d.append("projectId", String(projectId));
  d.append("staffId", String(staffId));
  await request.post("remove_project_member.php", d);
}
